var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactorClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.7 50.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.3,19.8h-21c-1.9-3.7-5.8-6.3-10.3-6.3c-4.5,0-8.4,2.6-10.3,6.3H47c-1.9-3.7-5.8-6.3-10.3-6.3c-4.5,0-8.4,2.6-10.3,6.3     h-21c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4h21c1.9,3.7,5.8,6.3,10.3,6.3c4.5,0,8.4-2.6,10.3-6.3h30.7c1.9,3.7,5.8,6.3,10.3,6.3     c4.5,0,8.4-2.6,10.3-6.3h21c3,0,5.4-2.4,5.4-5.4C124.7,22.2,122.3,19.8,119.3,19.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactorClosedIcon);
export default __webpack_public_path__ + "static/media/contactor-closed-icon.41ca94493405e8064e1d969cb2275207.svg";
export { ForwardRef as ReactComponent };